import styles from './_songTabs.module.scss'
import artists from '../../../../utils/songs/artists'
import { t } from '../../../../utils/i18n'
import { DropdownOption } from '../../../../components/Dropdown'
import { albumPath } from '../../../../utils/routeHelpers'
import Link from 'next/link'
import { ChangeType } from '../../../../utils/songs/songTabsCommon'
import { Song, Album } from '../../../../__generated__/graphql'

interface SongDetailsProps {
  song: Song
  songKey?: DropdownOption
  capo?: DropdownOption
  transposeCapoKey?: string
  pushChange?: (pushChangeProps: ChangeType) => void
  children?: React.ReactNode
}

const AlbumLink = (album: Album) => {
  return <Link href={albumPath(album)}>{album.name}</Link>
}

const SongDetails: React.FC<SongDetailsProps> = ({
  song,
  songKey,
  capo,
  transposeCapoKey,
  children
}) => {
  const songKeyValue = (songKey: DropdownOption, song: Song) => {
    if (songKey && songKey.value !== 'numbers') {
      return songKey.value
    } else {
      return song.key
    }
  }

  return (
    <div className={styles.songDetailsContainer}>
      <div className={styles.songDetailsHeader}>
        <h3 className={styles.songTitle}>{song.title}</h3>
        {children}
      </div>
      <div className={styles.songDetails}>
        <div className={styles.songDetailsTitle}>
          {artists(song)} | {AlbumLink(song.album)}
        </div>
        <div className={styles.songDetailsInfo}>
          <div>
            {`${t('KEY')} `}
            <strong>{songKeyValue(songKey, song)}</strong>
          </div>
          <div>
            {`${t('BPM')} `}
            <strong>{song.bpm}</strong>
          </div>
          <div>
            {`${t('TIME SIG')} `}&nbsp;<strong>{song.timeSignature}</strong>
          </div>
          {capo && capo.value !== '0' && (
            <div>
              {t('CAPO')}&nbsp;
              <strong>{`${capo.value} (${transposeCapoKey})`}</strong>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SongDetails
